import script from "./DeliveryEntityRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeliveryEntityRow.vue?vue&type=script&lang=ts&setup=true"

import "./DeliveryEntityRow.vue?vue&type=style&index=0&id=28d23a66&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28d23a66"]])

export default __exports__